/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_ResetInputs */

const en_home_bench_reset = /** @type {(inputs: Home_Bench_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const lv_home_bench_reset = /** @type {(inputs: Home_Bench_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atiestatīt`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Home_Bench_ResetInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_reset = /** @type {((inputs?: Home_Bench_ResetInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_ResetInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_reset(inputs)
	return en_home_bench_reset(inputs)
});